import { EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { AuthService } from './auth.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./auth.service";
var ReportsService = /** @class */ (function () {
    function ReportsService(http, authService) {
        this.http = http;
        this.authService = authService;
        this.onEditEvent = new EventEmitter();
    }
    ReportsService.prototype.getReports = function (filterParams) {
        return this.http.get(environment.apiUrl + "/" + this.authService.getUserType() + "/tasks/reports", { params: filterParams })
            .pipe(map(function (res) { return res; }));
    };
    ReportsService.ngInjectableDef = i0.defineInjectable({ factory: function ReportsService_Factory() { return new ReportsService(i0.inject(i1.HttpClient), i0.inject(i2.AuthService)); }, token: ReportsService, providedIn: "root" });
    return ReportsService;
}());
export { ReportsService };
